interface Email {
	system: string;
	value: string;
	use: string;
	emailStatus: 'Valid' | 'Invalid';
}

interface Telecom {
	system: string;
	value: string;
	use: string;
}

interface ConsentItem {
  name: string;
  type: string;
  sourceReference: string;
  consentType: string;
  status: 'Opt-in' | 'Opt-out';
  locale?: string;
  termsAndCondition?: boolean;
}

interface UpdatePreferencePayload {
  loginMemberId: string;
  status?: 'Opt-in' | 'Opt-out'; // Made optional for multi-consent scenarios
  email?: Email[];
  emailStatus?: 'Opt-in' | 'Opt-out'; // Specific status for email
  telecom?: Telecom[];
  telecomStatus?: 'Opt-in' | 'Opt-out'; // Specific status for telecom
  termsAndCondition?: boolean;
  preferences?: {
    option: string; // "email", "text", "email,text", "None"
  };
}

export const updatePreferenceHelper = (payload: UpdatePreferencePayload) => {
  const {
    loginMemberId,
    status,
    email,
    emailStatus,
    telecom,
    telecomStatus,
    termsAndCondition,
    preferences,
  } = payload;

  const consentArray: ConsentItem[] = [];

  // If neither email nor telecom is provided, add EOB/Paperless consent with the general status
  if (!email && !telecom && status) {
    consentArray.push({
      name: 'EOB|Paperless|SHP',
      type: 'PaperlessConsents',
      sourceReference: 'Member Portal',
      consentType: 'affirmative',
      status,
    });
  }

  //  Add Email consent if email is provided
  if (email) {
    consentArray.push({
      name: 'Email|SHP',
      type: 'EmailConsents',
      sourceReference: 'Member Portal',
      consentType: 'affirmative',
      status: emailStatus || status || 'Opt-out',
      locale: 'en_US',
    });
  }

  // Add Phone/TCPA consent if telecom is provided
  if (telecom) {
    consentArray.push({
      name: 'TCPA|SHP',
      type: 'PhoneAutodialConsents',
      sourceReference: 'Member Portal',
      consentType: 'affirmative',
      status: telecomStatus || status || 'Opt-out',
      locale: 'en_US',
      ...(termsAndCondition !== undefined && { termsAndCondition }),
    });
  }

  const basePayload = {
    resourceType: 'profile',
    active: true,
    identifier: [
      {
        value: loginMemberId,
        system: 'memberId',
      },
    ],
    ...(email && { email }),
    ...(telecom && { telecom }),
    ...(consentArray.length > 0 && { Consent: consentArray }),
  };

  // Add Preferences if provided
  if (preferences) {
    return {
      ...basePayload,
      Preferences: [
        {
          identifier: [
            {
              value: 'Preferred Channel',
              system: 'https://sentara/possibleNow/identifier/preferencetype',
            },
          ],
          option: preferences.option,
        },
      ],
    };
  }

  return basePayload;
};

// New helper function for preference-only updates
export const updatePreferenceOnlyHelper = (loginMemberId: string, option: string) => {
	return {
		resourceType: 'profile',
		active: true,
		identifier: [
			{
				value: loginMemberId,
				system: 'memberId',
			},
		],
		Preferences: [
			{
				identifier: [
					{
						value: 'Preferred Channel',
						system: 'https://sentara/possibleNow/identifier/preferencetype',
					},
				],
				option: option,
			},
		],
	};
};
